import React from 'react';
import moment from 'moment';
import {Map} from 'immutable';
import utils from '../utility/utils';
import {connect} from 'react-redux';
import api from '../utility/api';
import ScheduleView from '../screens/schedules';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';

const generateTimeSlot = (date, operatingHours) => {
  let slots = [];

  if(!operatingHours)
    return slots;

  let current = moment(date);
  let endTime = moment(date);

  current.set({
    hour:   operatingHours.startTime.get('hour'),
    minute: operatingHours.startTime.get('minute')
  });

  endTime.set({
    hour:   operatingHours.endTime.get('hour'),
    minute: operatingHours.endTime.get('minute')
  });

  while (current <= endTime) {
    let slot = new moment(current);
    slots.push(slot);
    current.add(operatingHours.interval, 'minutes');
  }
  return slots;
};

class Scheduler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slots: [],
      doctors: [],
      schedules: Map(),
      date: moment(),
      doctorId: null,
      appointmentId: null,
      startTime:'',
      operatingHours: [],
      renderFormOpen:false,
      schedule_start: '',
      schedule_end: '',
      selectedDoctor:{},
      showSchedulesOpen: false,
      dialogData: null,
      clickedSlot: null,
      clickedDoctor: null,
      scheduleId: null
    }
  }

  componentDidMount() {
    this.getOperatingHour()
      .then(()=> {
        this.getSchedules();
        this.getDoctorsList();
      });
  }

  getOperatingHour(){
    return api.getOperatingHour()
      .then((res)=>{
        let {startTime, endTime, interval} = res;
        let operatingHours = {
          startTime: moment({hour: startTime.hour, minute: startTime.minute}),
          endTime: moment({hour: endTime.hour, minute: endTime.minute}),
          interval: interval //minutes
        };
        this.setState({operatingHours});
      })
  }

  getSchedules() {
    api.getDoctorSchedule(this.state.date.toISOString())
        .then((data) => {
          let slots = generateTimeSlot(this.state.date, this.state.operatingHours);
          this.setState({
            slots,
            schedules: data.schedules,
            appointments: data.appointments,
          });
        })
        .catch((error) => {
          console.log(error);
        })
  }

  getDoctorsList() {
    api.getDoctors()
      .then(resp => {
        resp = resp.filter((doctor) => doctor.user.provider === true);
        this.setState({doctors: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
        console.log(error);
      });
  }

  submitSchedule() {
    let {operatingHours, selectedDoctor} = this.state;
    let {schedule_start: start_time, schedule_end: end_time} = this.state;
    let {id:doctorId} = selectedDoctor;
    operatingHours = generateTimeSlot(this.state.date, operatingHours);
    let scheduleDateString = utils.toDate(this.state.date);
    let startTimeString = utils.toAppTime(operatingHours[start_time]);
    let endTimeString = utils.toAppTime(operatingHours[end_time]);


    start_time = moment(scheduleDateString + ' ' + startTimeString, 'MM/DD/YYYY h:mm a');
    end_time = moment(scheduleDateString + ' ' + endTimeString, 'MM/DD/YYYY h:mm a');
    let body = {
      doctorId,
      start_time: start_time.toISOString(),
      end_time: end_time.toISOString()
    };
    api.submitSchedule(body)
      .then(() => this.getSchedules())
      .then(() => {
        this.setState({schedule_start: '', schedule_end: ''});
        this.props.dispatch(showFeedback({message: `Schedule added successfully`}));
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  deleteSchedule(scheduleId) {
    let id = scheduleId;
    this.props.dispatch(asyncStart());
    api.deleteSchedule(id)
      .then(() => this.getSchedules())
      .then(() => {
        this.props.dispatch(asyncEnd());
        this.setState({showSchedulesOpen: !this.state.showSchedulesOpen});
        this.props.dispatch(showFeedback({message: `Schedule deleted successfully`}));
        })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
        });
  }


  onNext() {
    let nextDay = this.state.date.add(1, 'day');
    this.setState({date: nextDay});
    this.getSchedules();
  };


  onPrevious() {
    let today = moment();
    if (!today.isSame(this.state.date, 'day')) {
      let prevDay = this.state.date.subtract(1, 'day');
      this.setState({date: prevDay});
      this.getSchedules();
    }
  }

  displayMissionDetail(appointment){
    this.setState({
      ...this.state,
      appointmentDetailDialogOpen:true,
      appointmentDetailDialogData:appointment,
    });
  }

  hideMissionDetail() {
    this.setState({
      ...this.state,
      appointmentDetailDialogOpen:false,
      appointmentDetailDialogData:null
    });
  }

  toggleRenderFormOpen() {
      this.setState({renderFormOpen: !this.state.renderFormOpen});
  }

  onScheduleChange(field, event, value) {
    let newState = {};
    if (field === 'schedule_start') {
      newState.schedule_start = value;
      newState.schedule_end = null;
    } else {
      newState.schedule_end = value;
    }
    this.setState(newState);
  }

  onSelectDoctor(_, __, selectedDoctor) {
    this.setState({selectedDoctor});
  }


  toggleShowSchedulesOpen() {
    this.setState({showSchedulesOpen: !this.state.showSchedulesOpen});
  }


  setSlotWithDoctor(clickedDoctor, clickedSlot)
  {
    this.setState({clickedDoctor, clickedSlot});
    this.setState({showSchedulesOpen: true});
  }

  setScheduleId(scheduleId) {
    this.setState({scheduleId});
  }


  render() {

    let {date, slots, schedules, appointments, doctorId, showSchedulesOpen,
      appointmentId, startTime, doctors, schedule_start, schedule_end, operatingHours,
      selectedDoctor, clickedDoctor, clickedSlot, scheduleId
    } = this.state;

    return (
        <ScheduleView
            date={date}
            slots={slots}
            doctors={doctors}
            doctorId={doctorId}
            showSchedulesOpen={showSchedulesOpen}
            schedules={schedules}
            startTime={startTime}
            appointments={appointments}
            appointmentId={appointmentId}
            onNext={this.onNext.bind(this)}
            onPrevious={this.onPrevious.bind(this)}
            displayMissionDetail={this.displayMissionDetail.bind(this)}
            schedule_start={schedule_start}
            schedule_end={schedule_end}
            submitSchedule={this.submitSchedule.bind(this)}
            onChange={this.onScheduleChange.bind(this)}
            operatingHours={operatingHours}
            selectedDoctor={selectedDoctor}
            onSelectDoctor={this.onSelectDoctor.bind(this)}
            toggleShowSchedulesOpen={this.toggleShowSchedulesOpen.bind(this)}
            deleteSchedule={this.deleteSchedule.bind(this)}
            clickedSlot={clickedSlot}
            clickedDoctor={clickedDoctor}
            setSlotWithDoctor={this.setSlotWithDoctor.bind(this)}
            scheduleId={scheduleId}
            setScheduleId={this.setScheduleId.bind(this)}

        />
    )

  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(Scheduler);



// WEBPACK FOOTER //
// ./src/containers/schedules.js